import qs from 'qs';
import DomianInfos from 'src/config/domain';
import { inApp, callHandlerToNative, isURL } from '@hst/utils';
import { isRealProd, isHK, ENV, isDev } from 'src/config/env';

export function getRedirectParamObj(type, valueObj) {
	return {
		redirectType: type,
		redirectValue: valueObj,
	};
}

/**
 * 通过window跳转
 * @param {String} path 不带域名的路径
 * @param {String} queryObj 拼接到链接上的参数
 * @param {String} root 域名
 */
export function jumpPathPageByWindow(path, queryObj, root) {
	const hostBase = root || '';
	const pathBase = path || '';
	const prefix = pathBase.includes('?') ? '&' : '?';

	let queryStr = queryObj ? qs.stringify(queryObj) : '';
	queryStr = queryStr ? `${prefix}${queryStr}` : '';
	const url = `${hostBase}${pathBase}${queryStr}`;
	if (inApp()) {
		// app内跳h5链接
		return callHandlerToNative({
			redirectType: '1',
			redirectValue: { url },
		});
	}
	if (window) {
		window.location.href = url;
	} else {
		throw new Error('window is not found.');
	}
}

/**
 * 马来中转页
 * @param {String} lang
 */
export function myTransferPage(lang, redirectData) {
	const value = encodeURIComponent(JSON.stringify(redirectData.redirectValue));
	const url = isRealProd
		? 'https://m.global.mplusonline.com/openapp'
		: 'https://feature.mplusglobal.com.my/openapp';
	window.location.href = `${url}?lang=${lang}&redirectType=${redirectData.redirectType}&redirectValue=${value}`;
}

/**
 * 主站中转页
 * @param {String} lang
 */

export function hkTransferPage(lang, redirectData) {
	const data = encodeURIComponent(JSON.stringify(redirectData));
	const appDeeplink = {
		zh_CN: 'cn-landing',
		zh_HK: 'hk-landing',
		en_US: 'hk-landing',
	};
	window.location.href = `https://h5${isRealProd ? '' : isDev ? 'feature' : ENV}.hstong.com/app-deep-link/${appDeeplink[lang]}?_app_redirect=${data}`;
}

/**
 * H5营销页跳转中转页
 * @param {String} lang
 */
export function jumpTransferPage(lang, redirectData) {
	if (isHK) {
		hkTransferPage(lang, redirectData);
	} else {
		myTransferPage(lang, redirectData);
	}
}

/**
 * H5营销页通用跳转
 * @param {Function} openMyApp
 * @param {*} path
 * @param {*} param
 * @param {String} lang
 */
export function commonH5Jump(path, param, lang) {
	// const params = { ...param, _app_fullScreen: 'y' };
	const redirectData = isURL(path)
		? getRedirectParamObj('1', { url: `${path}?${qs.stringify(param)}` })
		: getRedirectParamObj(path, param);

	if (inApp()) {
		// app内跳原生页
		return callHandlerToNative(redirectData);
	} else {
		// 站外
		isHK ? hkTransferPage(lang, redirectData) : myTransferPage(lang, redirectData);
	}
}

/**
 * 获取登录地址
 */
const getPassportUrl = (param) => {
	/** 判断链接有带渠道号，则先缓存 */

	const params = qs.stringify({
		target: window.location.href,
		...param,
	});

	const passportHoat = DomianInfos.login;
	return `${passportHoat}/passport/login?${params}`;
};

// /**
//  * App 内唤起登录页
//  *
//  */
function toNativeLogin() {
	callHandlerToNative({
		type: 'LOGIN',
		data: {
			needPop: 'n', // IOS，关闭登录，是否需要返回上一页
			url: location.href,
		},
	});
}

/**
 * 跳转到登录页
 */
export function goLogin(param) {
	// const route = opts?.to || window.location.origin;
	// beacon 探针上报
	//   goToLoginBeacon()
	// 如果不在APP中自动跳转到登录页
	if (!inApp()) {
		window.location.replace(getPassportUrl(param));
		return;
	}
	// 处理 webview action 标识
	// handleWebviewAction({ route })
	toNativeLogin();
}
